__turbopack_context__.v({
  "freeBox___6ZXgJ": "PlasmicWhyRerum-module__rWZOpa__freeBox___6ZXgJ",
  "freeBox__oxFp": "PlasmicWhyRerum-module__rWZOpa__freeBox__oxFp",
  "freeBox__pWdT1": "PlasmicWhyRerum-module__rWZOpa__freeBox__pWdT1",
  "freeBox__vaxvz": "PlasmicWhyRerum-module__rWZOpa__freeBox__vaxvz",
  "h1": "PlasmicWhyRerum-module__rWZOpa__h1",
  "img__loD5Z": "PlasmicWhyRerum-module__rWZOpa__img__loD5Z",
  "root": "PlasmicWhyRerum-module__rWZOpa__root",
  "slotTargetChildren": "PlasmicWhyRerum-module__rWZOpa__slotTargetChildren",
  "slotTargetSlot": "PlasmicWhyRerum-module__rWZOpa__slotTargetSlot",
});
